import React from 'react';

function Navbar({ goToHomePage }) {
  return (
    <nav className="navbar">
      <img src="/newlogo.png" alt="Logo" className="navbar-logo" />
      <div className="nav-brand">
        <span className="navbar-brand" onClick={goToHomePage}>
          AI Movie<span className="brand-highlight"> Recommendation</span>
        </span>
      </div>
    </nav>
  );
}

export default Navbar;
